module.exports = __webpack_public_path__ + "static/media/20ECE17.2fd03daf.jpg";